import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";

const DreamsContext = createContext(null);
export const useDreams = () => useContext(DreamsContext);

async function fetchMe() {
  try {
    const { data } = await api.get("/me");
    return { data };
  } catch (e) {
    return { error: e?.response?.status === 401 ? "AUTH" : (e.message || "Erro") };
  }
}

export function DreamsProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    const r = await fetchMe();
    if (r.error) setError(r.error);
    else { setError(null); setMe(r.data); }
    setLoading(false);
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const r = await fetchMe();
      if (cancelled) return;
      if (r.error) setError(r.error);
      else setMe(r.data);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  const isSubscribed = !!me?.subscription && me.subscription.Estado === "PG";
  const trialEligible = !!me?.trial_eligible;
  const emTrial = !!me?.em_trial;
  const diasRestantes = me?.dias_restantes ?? null;

  const startTrial = useCallback(async () => {
    await api.post("/subscribe/trial");
    await refresh();
  }, [refresh]);

  return (
    <DreamsContext.Provider
      value={{ me, loading, error, isSubscribed, refresh, trialEligible, emTrial, diasRestantes, startTrial }}
    >
      {children}
    </DreamsContext.Provider>
  );
}
